import { OctoberPrizeDrawPage } from 'pageModules/OctoberPrizeDrawPage';

export default OctoberPrizeDrawPage;
